import { render, staticRenderFns } from "./department-process-form.vue?vue&type=template&id=3e433b44"
import script from "./department-process-form.vue?vue&type=script&lang=js"
export * from "./department-process-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports